import React, { useEffect, useState } from "react";
import ProgressTabs from "../signup/ProgressTabs";
import { scrollSignupToTop } from "../signup/scrollSignup";
import Terms from "../new_org_page/Terms";
import Beliefs from "../new_org_page/Beliefs";
import UserInfo from "./UserInfo";
import UserSubmit from "./UserSubmit";

/**
 * Public individual signup wizard: terms, info, beliefs, submit.
 *
 * @param {Object} props
 * @param {function(Object): void} [props.onSetUser]
 * @returns {JSX.Element}
 */
export default function NewUserPage({ onSetUser }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    confirm_password: "",
    phone: "",
    location: "",
    latitude: null,
    longitude: null,
    pfp_url: "",
  });
  const [beliefs, setBeliefs] = useState({
    denomination: "",
    niceneCreedAgreed: false,
  });
  const [termsAgreed, setTermsAgreed] = useState(false);

  const steps = [
    { label: "Terms & Conditions", number: 1 },
    { label: "Your Info", number: 2 },
    { label: "Beliefs", number: 3 },
    { label: "Review & Submit", number: 4 },
  ];

  const displayName =
    `${formData.first_name || ""} ${formData.last_name || ""}`.trim() || "you";

  useEffect(() => scrollSignupToTop(), [currentStep]);

  return (
    <main className="min-h-screen bg-primary px-4 py-8 text-text-primary">
      <div id="signup-scroll-top" />
      <div className="mx-auto max-w-4xl">
        <h1 className="mb-8 text-center text-3xl font-bold">Create an account</h1>
        <ProgressTabs steps={steps} currentStep={currentStep} />
        <div className="rounded-lg border border-border bg-secondary p-8 shadow-md">
          {currentStep === 0 && (
            <Terms
              termsAgreed={termsAgreed}
              onTermsAgreedChange={setTermsAgreed}
              onNext={() => setCurrentStep(1)}
            />
          )}
          {currentStep === 1 && (
            <UserInfo
              formData={formData}
              onFormDataUpdate={(updates) => setFormData((prev) => ({ ...prev, ...updates }))}
              onBack={() => setCurrentStep(0)}
              onNext={() => setCurrentStep(2)}
            />
          )}
          {currentStep === 2 && (
            <Beliefs
              formData={{ name: displayName }}
              beliefs={beliefs}
              onBeliefsUpdate={setBeliefs}
              onBack={() => setCurrentStep(1)}
              onNext={() => setCurrentStep(3)}
              subjectLabel="your"
            />
          )}
          {currentStep === 3 && (
            <UserSubmit
              formData={formData}
              beliefs={beliefs}
              termsAgreed={termsAgreed}
              onBack={() => setCurrentStep(2)}
              onSetUser={onSetUser}
            />
          )}
        </div>
      </div>
    </main>
  );
}
